import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CompactCarPage = lazy(() => import('../pages/compact-car/page'));
const MidsizeCarPage = lazy(() => import('../pages/midsize-car/page'));
const FullsizeCarPage = lazy(() => import('../pages/fullsize-car/page'));
const SUVCarPage = lazy(() => import('../pages/suv-car/page'));
const VanCarPage = lazy(() => import('../pages/van-car/page'));
const InsuranceTermsPage = lazy(() => import('../pages/insurance-terms/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const LocationPage = lazy(() => import('../pages/location/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/compact-car',
    element: <CompactCarPage />,
  },
  {
    path: '/midsize-car',
    element: <MidsizeCarPage />,
  },
  {
    path: '/fullsize-car',
    element: <FullsizeCarPage />,
  },
  {
    path: '/suv-car',
    element: <SUVCarPage />,
  },
  {
    path: '/van-car',
    element: <VanCarPage />,
  },
  {
    path: '/insurance-terms',
    element: <InsuranceTermsPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/location',
    element: <LocationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;